export const parseJwt = (token) => {
  try {
    const [, payload] = token.split('.');
    if (!payload) return null;
    return JSON.parse(atob(payload.replace(/-/g, '+').replace(/_/g, '/')));
  } catch (err) {
    return null;
  }
};

export const isTokenExpired = (token) => {
  const payload = parseJwt(token);
  if (!payload) return true;
  if (!payload.exp) return false;
  return payload.exp * 1000 <= Date.now();
};

export const clearAuth = () => {
  localStorage.removeItem('token');
};

export const getValidToken = () => {
  const token = localStorage.getItem('token');
  if (!token) return null;
  if (isTokenExpired(token)) {
    clearAuth();
    return null;
  }
  return token;
};

export const getAuthUser = () => {
  const token = getValidToken();
  if (!token) return null;
  return parseJwt(token);
};

export const hasRole = (requiredRole) => {
  const user = getAuthUser();
  return !!user && user.role === requiredRole;
};
